import React, {HTMLProps} from "react";

const Field: React.FC<HTMLProps<HTMLDivElement>> = props => {
  return (
      <div {...props} style={{
        marginBottom: '0.5em',
        ...props.style
      }}>
        {props.children}
      </div>
  );
};
export default Field;